import { configureStore } from "@reduxjs/toolkit";
import featureGroupReducer from "./slices/featureGroupWithFeatureSlice";
import adminReducer from "./slices/adminSlice";
import roleAssignmentRequestsReducer from "./slices/RoleAssignmentRequestsSlice";
import toastReducer from "./slices/toastSlice";
import loaderReducer from "./slices/loaderSlice";
import featurePermissionReducer from "./slices/featurePermissionSlice";
import roleArchivedAssignmentRequestsReducer from "./slices/roleArchivedAssignmentRequestsSlice";
import applicationListReducer from "./slices/applicationListSlice";
import applicationDetailsReducer from "./slices/applicationDetailsSlice";
import featureListReducer from "./slices/featureListSlice";
import createApplicationReducer from "./slices/CreateApplicationSlice";
import createRoleReducer from "./slices/CreateRoleSlice";
import createFeatureReducer from "./slices/createFeatureSlice";
import createApiReducer from "./slices/createApiSlice";
import apiDetailsreducer from "./slices/apiDetailsSlice";
import applicationDomainReducer from "./slices/applicationDomainSlice";
import userGroupsReducer from "./slices/userGroupSlice";
import permissionReducer from "./slices/PermissionSlice/permissionSlice";

export const store: any = configureStore({
  reducer: {
    loader: loaderReducer,
    featureGroupWithFeature: featureGroupReducer,
    admin: adminReducer,
    roleAssignmentRequests: roleAssignmentRequestsReducer,
    roleArchivedAssignmentRequests: roleArchivedAssignmentRequestsReducer,
    toast: toastReducer,
    featurePermission: featurePermissionReducer,
    applicationList: applicationListReducer,
    applicationDetails: applicationDetailsReducer,
    featureList: featureListReducer,
    createApplication: createApplicationReducer,
    createFeature: createFeatureReducer,
    createApi: createApiReducer,
    apiDetails: apiDetailsreducer,
    //deleteFeature: deleteFeatureReducer,
    createRole: createRoleReducer,
    applicationDomain: applicationDomainReducer,
    userGroups: userGroupsReducer,
    permission: permissionReducer,
  },
});

// Automatically infer types for better TypeScript support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
